import SurfaceCard from "@/components/primitives/SurfaceCard";
import RichTextRenderer from "@/components/ui/rich-text-renderer";

interface MissionStatementProps {
  mission: string;
}

const MissionStatement = ({ mission }: MissionStatementProps) => {
  return (
    <SurfaceCard padding="lg" className="rounded-2xl">
      <div className="mx-auto max-w-[820px]">
        <div className="eyebrow mb-3.5 text-primary">Mission</div>
        <div className="font-display text-[26px] font-medium leading-[1.34] text-ink-900">
          <RichTextRenderer
            content={mission}
            className="prose-p:text-inherit prose-p:text-[length:inherit] prose-p:font-medium prose-p:leading-[1.34] prose-strong:font-semibold"
          />
        </div>
      </div>
    </SurfaceCard>
  );
};

export default MissionStatement;
